import '@sass/cw-utm-main.scss';

/**
 * Gravity Forms UTM Cookie Tracker
 * Uses a localized MutationObserver to eliminate CPU overhead while defeating NitroPack.
 */
(function() {
    'use strict';

    // Parameters array
    const UTM_PARAMS = [
        'utm_source', 
        'utm_medium', 
        'utm_campaign', 
        'utm_term', 
        'utm_content', 
        'utm_adgroup',
        'gclid', 
        'fbclid',
        'cw_utm_landing_page',  // (Landing page - first touch)
        'cw_utm_conversion_page', // (last touch referral)
        'cw_utm_submission_page', // (last touch url)
        'organic_source_str',
        'organic_source',
        'visitor_information'
    ];
    const COOKIE_EXPIRY_DAYS = 30;

    /**
     * Client-side sanitization helper to strip HTML tags and prevent XSS injections.
     */
    function sanitizeInput(string) {
        if (!string) return '';
        const temp = document.createElement('div');
        temp.textContent = string;
        return temp.innerHTML; // Safely escapes symbols like <, >, &
    }

    /**
     * Sets a highly secure cookie.
     */
    function setSecureCookie(name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        const expires = "; expires=" + date.toUTCString();
        let cookieString = name + "=" + encodeURIComponent(value) + expires + "; path=/; SameSite=Lax";
        if (window.location.protocol === 'https:') {
            cookieString += "; Secure";
        }
        document.cookie = cookieString;
    }

    /**
     * Reads a cookie value by name.
     */
    function getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i].trim();
            if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
    }

    /**
     * Captures UTMs from URL, sanitizes them, and writes them to secure cookies.
     * Also captures clean landing page, conversion page (referrer), and submission page (full URL).
     */
    function captureUTMs() {
        const urlParams = new URLSearchParams(window.location.search);
        
        // 1. Standard UTMs and Click IDs
        UTM_PARAMS.forEach(param => {
            if (urlParams.has(param)) {
                setSecureCookie(param, sanitizeInput(urlParams.get(param)), COOKIE_EXPIRY_DAYS);
            }
        });

        // 2. Landing Page (origin + pathname without query strings)
        if (!getCookie('cw_utm_landing_page')) {
            const landingPage = window.location.origin + window.location.pathname;
            setSecureCookie('cw_utm_landing_page', sanitizeInput(landingPage), COOKIE_EXPIRY_DAYS);
        }

        // 3. Conversion Page (External referrer / initial source page)
        if (!getCookie('cw_utm_conversion_page')) {
            let ref = document.referrer;
            if (ref && !ref.includes(window.location.hostname)) {
                setSecureCookie('cw_utm_conversion_page', sanitizeInput(ref), COOKIE_EXPIRY_DAYS);
            } else if (!ref) {
                setSecureCookie('cw_utm_conversion_page', 'direct', COOKIE_EXPIRY_DAYS);
            }
        }

        // 4. Submission Page LAST TOUCH (Always updates so it reflects the page they submit on)
        setSecureCookie('cw_utm_submission_page', sanitizeInput(window.location.href), COOKIE_EXPIRY_DAYS);
    }

    /**
     * Core Population Engine. Restricted to a specific form container for safety.
     */
    function populateFormFields(container = document) {
        UTM_PARAMS.forEach(param => {
            const cookieValue = getCookie(param);
            if (!cookieValue) return;

            // Highly targeted query: Only looks for input tags with our specific attribute
            const fields = container.querySelectorAll(`input[data-parameter-name="${param}"]`);
            fields.forEach(field => {
                if (!field.value || field.value === '') {
                    field.value = sanitizeInput(cookieValue);
                }
            });
        });
    }

    // --- Initialization Pipeline ---
    
    // 1. Instantly parse URL parameters/metadata and store them in cookies
    captureUTMs();

    // 2. Setup isolated watchdogs for each Gravity Form on the page
    function initTracker() {
        // Initial run in case elements loaded quickly
        populateFormFields();

        // Target ONLY the Gravity Form containers
        const formWrappers = document.querySelectorAll('.gform_wrapper');
        
        formWrappers.forEach(wrapper => {
            const observer = new MutationObserver(function() {
                // Relentlessly updates fields inside this form if the cache overwrites them
                populateFormFields(wrapper);
            });

            // Start watching ONLY this specific form area
            observer.observe(wrapper, {
                childList: true,
                subtree: true
            });
        });
    }

    // 3. Ensure DOM execution timing is synchronized
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initTracker);
    } else {
        initTracker();
    }

    // 4. Secondary fallback wrapper for native Gravity AJAX transitions/paginations
    if (window.jQuery) {
        jQuery(document).on('gform_post_render', function() {
            populateFormFields();
        });
    }

})();